import {
  Box,
  Grid,
  DialogContent,
} from "@mui/material";

import "./style.css";

const ConteudoModalModulosString = () => {
    return (
        <Box>
            <Box component="strong">
                <Box component="span" style={{ color: "red" }} >*</Box> Informações importantes!
            </Box>
            <DialogContent>
                <Grid size={12}>
                    <Box component="p">A quantidade de módulos no projeto deve permitir uma configuração que atenda o seguinte requisito técnico:</Box>
                    <Box component="p"  style={{ textDecoration: "underline" }}>As strings que pertencem ao mesmo MPPT devem ter a mesma quantidade de módulos fotovoltaicos conectados em série ou deve ser utilizado uma única string, respeitado o número máximo de módulos por string.</Box>
                    <Box component="p">Caso esse requisito não seja atendido, sugerimos as seguintes alterações:</Box>
                    <Box component="ul">
                        <Box component="li">Altere a quantidade de módulos; ou</Box>
                        <Box component="li">Altere o modelo e/ou quantidade do inversor;</Box>
                    </Box>
                    <Box component="p">Caso opte por seguir com uma quantidade de módulos que não atenda o requisito técnico acima, a Intelbras se reserva o direito de não garantir o funcionamento do sistema, podendo recusar a cobertura da garantia em caso de falhas decorrentes dessa incompatibilidade.</Box>
                </Grid>
            </DialogContent>
        </Box>
    );
};

export { ConteudoModalModulosString };
